import { EntryTransformer } from '../components/ArticleRichText/entryTransformersMap';
import { ContentfulImage } from '@jbhi-fi/components/src/ContentfulImage/ContentfulImage';
import { ContentfulAsset } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';
import { VideoPlayer } from '@jbhi-fi/components/src/VideoPlayer/VideoPlayer';

const commonProps: Partial<EntryTransformer> = {
  loadingProps: { height: '250px' },
  layoutBlockProps: { paddingTop: 10 },
};

export const determineAssetTransformer = ({ fields }: ContentfulAsset): EntryTransformer => {
  if (fields?.file?.contentType?.includes('image'))
    return {
      ...commonProps,
      OutputComponent: ContentfulImage,
      transformer: asset => ({ ...AssetTransformer.toContentfulImageProps(asset), fillParent: true }),
    };
  if (fields?.file?.contentType?.includes('video')) {
    return {
      ...commonProps,
      OutputComponent: VideoPlayer,
      transformer: AssetTransformer.toVideoPlayerProps,
    };
  }
  return {
    ...commonProps,
    transformer: () => commonProps.loadingProps,
    OutputComponent: LoadingSkeleton.Box,
  };
};
